import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { Observable, of, throwError } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class StorageService {

	protected prefix = 'fasttrack_';

	get size(): Observable<number> {
		return of(localStorage.length);
	}

	constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

	public getItem<T = any>(key: string): Observable<T | null> {

		const unparsedData = isPlatformBrowser(this.platformId) ?
			localStorage.getItem(`${this.prefix}${key}`) : null;
		let parsedData: T | null = null;

		if (unparsedData != null) {
			try {
				parsedData = JSON.parse(unparsedData);
			} catch (error) {
				return throwError(new Error(`Invalid data in localStorage.`));
			}
		}
		return of(parsedData);
	}

	public getItemSync<T = any>(key: string): T {
		const unparsedData = isPlatformBrowser(this.platformId) ?
			localStorage.getItem(`${this.prefix}${key}`) : null;
		let parsedData: T | null = null;

		if (unparsedData != null) {
			try {
				parsedData = JSON.parse(unparsedData);
			} catch (error) {
				return null;
			}
		}
		return parsedData;
	}

	public setItem(key: string, data: any): Observable<boolean> {
		if (data !== undefined) {
			if (isPlatformBrowser(this.platformId)) {
				localStorage.setItem(`${this.prefix}${key}`, JSON.stringify(data));
				return of(true);
			}
			return of(false);
		}
	}

	public setItemSync(key: string, data: any): void {
		if (data !== undefined) {
			if (isPlatformBrowser(this.platformId)) {
				localStorage.setItem(`${this.prefix}${key}`, JSON.stringify(data));
			}
		}
	}

	public removeItem(key: string): Observable<boolean> {
		if (isPlatformBrowser(this.platformId)) {
			localStorage.removeItem(`${this.prefix}${key}`);
		}
		return of(true);
	}

	public clearAll(): Observable<boolean> {
		if (isPlatformBrowser(this.platformId)) {
			localStorage.clear();
		}
		return of(true);
	}

	public keys(): Observable<string[]> {
		const keys: string[] = [];
		if (isPlatformBrowser(this.platformId)) {
			for (let index = 0; index < localStorage.length; index += 1) {
				keys.push(this.getKey(index) as string);
			}
		}
		return of(keys);
	}

	public has(key: string): Observable<boolean> {
		if (isPlatformBrowser(this.platformId)) {
			for (let index = 0; index < localStorage.length; index += 1) {
				if (key === this.getKey(index)) {
					return of(true);
				}
			}
		}
		return of(false);
	}

	protected getKey(index: number): string | null {
		if (isPlatformBrowser(this.platformId)) {
			const prefixedKey = localStorage.key(index);
			if (prefixedKey !== null) {
				return this.prefix === ''
					? prefixedKey
					: prefixedKey.substr(this.prefix.length);
			}
		}
		return null;
	}
}
